import clsx from 'clsx';
import { CSSProperties, useEffect, useState } from 'react';
import { Tooltip } from '../Tooltip';

interface Props {
  className?: string;
  total: number;
  label: string;
  backgroundColor?: string;
  color?: string;
  loading?: boolean;
  onSelect?(metric: string): void;
  selectedValue: any;
  value: any;
}

export const BubbleMetric = ({
  className,
  total,
  label,
  backgroundColor,
  color,
  loading,
  onSelect,
  selectedValue,
  value,
}: Props) => {
  const [selected, setSelected] = useState(selectedValue === value);
  const customStyles: CSSProperties = {
    color: color,
    backgroundColor: backgroundColor,
  };

  const handleClick = () => {
    if (onSelect !== undefined) {
      setSelected(!selected);
      value ? onSelect(value) : label;
    }
  };

  useEffect(() => {
    setSelected(selectedValue === value);
  }, [selectedValue]);

  useEffect(() => {
    if (!selected && onSelect !== undefined && selectedValue === value) {
      onSelect('');
    }
  }, [selected]);

  return (
    <div
      className={clsx(
        className,
        'flex flex-row items-center justify-center m-4',
        {
          'cursor-pointer': onSelect !== undefined && total > 0,
        }
      )}
      onClick={total > 0 ? handleClick : () => {}}
    >
      <Tooltip
        title={onSelect && total > 0 ? `Filter ${label}` : label}
        showArrow
        placement="top"
      >
        <span
          style={customStyles}
          className="flex items-center justify-center text-[1.4rem] min-w-[35px] min-h-[35px] w-auto h-[35px] rounded-full mr-2 p-[5px]"
        >
          {loading !== undefined ? (loading ? '-' : total) : total}
        </span>
      </Tooltip>
      <h5
        style={{ borderColor: backgroundColor }}
        className={clsx('whitespace-nowrap text-[1.2rem]', {
          'relative top-[1px] border-b-[2px]': selected,
          'hover:relative hover:top-[1px] hover:border-b-[2px]':
            onSelect !== undefined && total > 0,
        })}
      >
        {label}
      </h5>
    </div>
  );
};
